import { useEffect, useRef } from 'react';
import './Logger.css';

type LoggerType = {
    message: string;
    type?: 'success' | 'error' | 'warn';
};

const Logger = ({ messages }: { messages: LoggerType[] }) => {
    const containerRef = useRef<null | HTMLDivElement>(null);

    const scrollToBottom = () => {
        if (containerRef.current) {
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    };

    useEffect(scrollToBottom, [messages]);

    return (
        <aside className='logger-container' ref={containerRef}>
            <ul>
                {messages.map((message, index) => (
                    <li
                        className={
                            message.type === 'success'
                                ? 'logger-success'
                                : message.type === 'error'
                                  ? 'logger-error'
                                  : message.type === 'warn'
                                    ? 'logger-warn'
                                    : ''
                        }
                        key={index}
                    >
                        {message.message}
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default Logger;
